/**
 * Default level of precision in node-sass is 5 decimal places.
 * Bootstrap v5 increased the rounding precision to 6 to prevent issues with browser rounding
 */
const ROUND_PRECISION = 1e6;

/**
 *
 * @example
 *  round(100 / 12 * 8) === 66.666667
 *  round(100 / 12 * 1) ===  8.333333
 */
export const roundToPrecision = (num: number, precision: number = ROUND_PRECISION) => {
  return Math.round(num * precision) / precision;
};
